import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";

// Layout and shared components
import { Layout } from "./components/Layout";
import Home from "./components/Home";
import { Auth0 } from "./components/shared/Auth0";
import Auth0Callback from "./components/shared/Auth0Callback";

// Admin components
import AdminAccountsContainer from "./components/Admin/AdminAccountsContainer";
import AdminSharedAccountCredentials from "./components/Admin/AdminSharedAccountCredentials";
import AdminClientUsers from "./components/Admin/AdminClientUsers";
import AdminSiteUsers from "./components/Admin/AdminSiteUsers";
import AdminAccessControlGroups from "./components/Admin/AdminAccessControlGroups";
import AdminTenetsContainer from "./components/Admin/AdminTenetsContainer";

// Key Requests components
import OpenDoor from "./components/KeyRequests/OpenDoor";
import KeyRequests from "./components/KeyRequests/KeyRequests";
import GuestInvite from "./components/KeyRequests/GuestInvite";
import AllInvites from "./components/KeyRequests/AllInvites";
import FromMeInvites from "./components/KeyRequests/FromMeInvites";
import FromMeAccessLog from "./components/KeyRequests/FromMeAccessLog";

// Other components
import AccessControlGroupDetail from "./components/AccessControlGroups/AccessControlGroup";
import ScreenInvite from "./components/ScreenInvites/ScreenInvite";
import Sites from "./components/Sites/Sites";
import Locks from "./components/Locks/Locks";
import AdminLocks from "./components/AdminLocks/Locks";
import Guests from "./components/AdminGuests/Guests";

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/callback" element={<Auth0Callback />} />
        <Route
          path="/"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <Home />
            </Auth0>
          }
        />

        {/* Routes requiring authentication for tenant users */}
        <Route
          path="/admin/*"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <Routes>
                <Route
                  path="accessControlGroups"
                  element={<AdminAccessControlGroups />}
                />
                <Route
                  path="accessControlGroups/:accessControlGroupId"
                  element={<AccessControlGroupDetail />}
                />
                <Route
                  path="sharedCredentials"
                  element={<AdminSharedAccountCredentials />}
                />
                <Route path="tenants" element={<AdminTenetsContainer />} />
                <Route path="accounts" element={<AdminAccountsContainer />} />
                <Route path="clientUsers" element={<AdminClientUsers />} />
                <Route path="sites/*" element={<Sites />} />
                <Route path="locks/*" element={<Locks />} />
                <Route path="locks2/*" element={<AdminLocks />} />
                <Route path="guests/*" element={<Guests />} />
                <Route path="siteUsers" element={<AdminSiteUsers />} />
              </Routes>
            </Auth0>
          }
        />

        {/* Tenant user routes */}
        <Route
          path="/openDoor"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <OpenDoor />
            </Auth0>
          }
        />
        <Route
          path="/KeyRequests"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <KeyRequests />
            </Auth0>
          }
        />
        <Route
          path="/allInvites"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <AllInvites />
            </Auth0>
          }
        />
        <Route
          path="/myInvite"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <GuestInvite />
            </Auth0>
          }
        />
        <Route
          path="/myScreenInvite"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <ScreenInvite />
            </Auth0>
          }
        />
        <Route
          path="/fromMeInvites"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <FromMeInvites />
            </Auth0>
          }
        />
        <Route
          path="/fromMeAccessLog"
          element={
            <Auth0 shouldRenderLogin={true} isForTenantUser={true}>
              <FromMeAccessLog />
            </Auth0>
          }
        />

        {/* Guest routes (no login required) */}
        <Route
          path="/guest/myInvite"
          element={
            <Auth0 shouldRenderLogin={false} isForTenantUser={false}>
              <GuestInvite />
            </Auth0>
          }
        />
        <Route
          path="/guest/myScreenInvite"
          element={
            <Auth0 shouldRenderLogin={false} isForTenantUser={false}>
              <ScreenInvite />
            </Auth0>
          }
        />
        <Route
          path="/guest/fromMeInvites"
          element={
            <Auth0 shouldRenderLogin={false} isForTenantUser={false}>
              <FromMeInvites />
            </Auth0>
          }
        />
        <Route
          path="/guest/fromMeAccessLog"
          element={
            <Auth0 shouldRenderLogin={false} isForTenantUser={false}>
              <FromMeAccessLog />
            </Auth0>
          }
        />

        {/* Catch all route - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
